var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartnurseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 27,
    viewBox: "0 0 156 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12486_30775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8465 21.2839C40.6656 21.2839 39.5386 21.1142 38.4663 20.7758C37.3936 20.4374 36.5332 20.0013 35.8853 19.4677L36.8571 17.2838C37.462 17.7595 38.2104 18.1561 39.1036 18.473C39.9962 18.7902 40.9106 18.9487 41.8468 18.9487C42.6386 18.9487 43.2794 18.8622 43.7694 18.6889C44.2587 18.516 44.619 18.2817 44.8495 17.9864C45.0797 17.691 45.195 17.3562 45.195 16.9811C45.195 16.5199 45.0293 16.1487 44.6979 15.8674C44.3666 15.5862 43.9383 15.3632 43.413 15.197C42.8871 15.0315 42.304 14.8801 41.6632 14.7428C41.0223 14.6059 40.3815 14.4369 39.741 14.2347C39.0998 14.0332 38.5132 13.7774 37.9806 13.4672C37.4476 13.1574 37.0193 12.7428 36.6957 12.2241C36.3717 11.705 36.2096 11.0423 36.2096 10.2349C36.2096 9.42758 36.4288 8.6601 36.8684 7.97554C37.3073 7.29097 37.977 6.74297 38.877 6.33223C39.7769 5.92149 40.918 5.71613 42.3005 5.71613C43.2079 5.71613 44.1075 5.83151 45.0004 6.06194C45.8929 6.29271 46.6705 6.62405 47.3333 7.05667L46.4478 9.24056C45.7706 8.83724 45.0723 8.53801 44.3525 8.34322C43.6323 8.14844 42.941 8.0514 42.279 8.0514C41.5155 8.0514 40.8891 8.14526 40.3998 8.33264C39.9102 8.52001 39.5538 8.76878 39.3307 9.0786C39.1072 9.38877 38.9958 9.73105 38.9958 10.1054C38.9958 10.567 39.1576 10.9379 39.4815 11.2191C39.8055 11.5003 40.2303 11.7198 40.7558 11.8786C41.2814 12.0374 41.8683 12.1888 42.5163 12.3327C43.1642 12.4771 43.8047 12.6464 44.4385 12.8409C45.0719 13.0353 45.655 13.288 46.1883 13.5974C46.7206 13.9076 47.1496 14.3183 47.4732 14.83C47.7972 15.3416 47.9593 15.9941 47.9593 16.7866C47.9593 17.5792 47.7397 18.34 47.3005 19.0245C46.8612 19.7091 46.1883 20.2571 45.281 20.6675C44.3736 21.0786 43.229 21.2839 41.8465 21.2839Z",
    fill: "#0078FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5078 21.0676V9.52144H53.0783V12.6133L52.6031 11.6838C52.9919 10.9488 53.557 10.3793 54.2987 9.97558C55.04 9.57225 55.8934 9.37006 56.8582 9.37006C57.9383 9.37006 58.8739 9.63718 59.6663 10.17C60.458 10.7035 60.984 11.5254 61.243 12.6351L60.2063 12.2459C60.5659 11.3955 61.1782 10.7039 62.0422 10.1704C62.9062 9.63753 63.9069 9.37041 65.0445 9.37041C65.9659 9.37041 66.783 9.55108 67.4962 9.911C68.2089 10.2716 68.7666 10.8267 69.1702 11.5758C69.5731 12.3257 69.7751 13.2841 69.7751 14.4517V21.068H67.0968V14.7975C67.0968 13.7742 66.8701 13.0102 66.4164 12.5056C65.9628 12.0014 65.318 11.7491 64.4833 11.7491C63.8925 11.7491 63.3711 11.8786 62.9175 12.1383C62.4638 12.398 62.1106 12.7837 61.8589 13.2954C61.6068 13.807 61.481 14.445 61.481 15.2086V21.0683H58.8023V14.7979C58.8023 13.7745 58.5756 13.0106 58.122 12.506C57.6683 12.0017 57.0239 11.7494 56.1888 11.7494C55.598 11.7494 55.0763 11.8789 54.6226 12.1387C54.1689 12.3984 53.8161 12.784 53.5644 13.2957C53.3124 13.8074 53.1865 14.4453 53.1865 15.209V21.0687H50.5082L50.5078 21.0676Z",
    fill: "#0078FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7083 21.219C75.8443 21.219 75.0885 21.0711 74.4406 20.7758C73.7927 20.4804 73.2921 20.0697 72.9393 19.5432C72.5864 19.0171 72.4102 18.4225 72.4102 17.7595C72.4102 17.0964 72.5649 16.5269 72.8748 16.0078C73.1843 15.4891 73.6919 15.0784 74.3976 14.7753C75.103 14.4725 76.0392 14.3211 77.2057 14.3211H80.5538V16.1158H77.4002C76.4929 16.1158 75.8774 16.2637 75.5535 16.559C75.2295 16.8547 75.0677 17.2259 75.0677 17.6727C75.0677 18.1483 75.2623 18.5305 75.6508 18.8184C76.0396 19.1071 76.5796 19.2507 77.2709 19.2507C77.9621 19.2507 78.5272 19.0993 79.0528 18.7965C79.5784 18.4941 79.9633 18.0474 80.2083 17.456L80.6405 19.0778C80.3814 19.7556 79.9203 20.2814 79.2579 20.6562C78.5952 21.0313 77.7461 21.2183 76.709 21.2183L76.7083 21.219ZM80.337 21.0676V18.7108L80.2073 18.2351V14.1486C80.2073 13.356 79.9661 12.7396 79.4839 12.2999C79.001 11.8602 78.2706 11.6404 77.2913 11.6404C76.6575 11.6404 76.0311 11.7413 75.4121 11.9432C74.7928 12.145 74.2598 12.4262 73.8138 12.7862L72.7556 10.8186C73.3891 10.3429 74.1304 9.98262 74.9803 9.73738C75.8298 9.49249 76.7153 9.36969 77.6371 9.36969C79.3218 9.36969 80.6179 9.77337 81.5253 10.5807C82.4326 11.3881 82.886 12.6277 82.886 14.2996V21.0672H80.337V21.0676Z",
    fill: "#0078FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.363 21.0676V9.52144H88.9335V12.6997L88.6314 11.7703C88.9624 10.9918 89.5025 10.3973 90.2515 9.98616C90.9999 9.57542 91.9147 9.37006 92.9947 9.37006V11.9432C92.8939 11.9287 92.7931 11.9181 92.6923 11.9107C92.5915 11.9036 92.4981 11.8998 92.4117 11.8998C91.3746 11.8998 90.554 12.1955 89.9491 12.7862C89.3442 13.3776 89.0417 14.2781 89.0417 15.4888V21.0673H86.3634L86.363 21.0676Z",
    fill: "#0078FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2039 11.6838V9.52145H101.893V11.6838H94.2039ZM100.079 21.219C98.8118 21.219 97.8326 20.8912 97.1416 20.2352C96.4504 19.5796 96.1046 18.6173 96.1046 17.3488V6.97021H98.7829V17.2623C98.7829 17.8103 98.9267 18.2355 99.2147 18.5379C99.5027 18.8407 99.906 18.9921 100.425 18.9921C101.015 18.9921 101.505 18.8336 101.893 18.5164L102.671 20.4409C102.34 20.7003 101.944 20.8951 101.483 21.0246C101.022 21.1544 100.555 21.2194 100.079 21.2194V21.219Z",
    fill: "#0078FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.116 21.0676V5.93243H122.153V8.31076H113.924V18.6893H122.456V21.068H111.116L111.116 21.0676ZM113.708 14.5378V12.2244H121.225V14.5378H113.708Z",
    fill: "#0078FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.588 21.0676V5.93243H127.899L137.381 17.6081H136.237V5.93243H139.001V21.0676H136.69L127.23 9.39195H128.374V21.0676H125.588Z",
    fill: "#0078FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.083 21.0676V5.93243H149.283C151.299 5.93243 152.879 6.41198 154.024 7.37037C155.169 8.32911 155.741 9.64425 155.741 11.3165C155.741 12.4266 155.482 13.3779 154.963 14.1705C154.445 14.9634 153.707 15.5759 152.75 16.0082C151.792 16.4408 150.643 16.6568 149.304 16.6568H144.66L145.892 15.4027V21.0676H143.083ZM145.892 15.7054L144.66 14.3434H149.174C150.413 14.3434 151.345 14.0766 151.972 13.5434C152.598 13.0102 152.911 12.2678 152.911 11.3165C152.911 10.3652 152.598 9.6266 151.972 9.10013C151.345 8.574 150.413 8.31111 149.174 8.31111H144.66L145.892 6.92752V15.7058V15.7054ZM152.976 21.0676L149.153 15.5756H152.156L156 21.0676H152.977H152.976Z",
    fill: "#0078FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3955 27C21.0009 27 18.239 24.2353 18.239 20.8372C18.239 17.4391 21.0009 14.6744 24.3955 14.6744C27.7902 14.6744 30.5521 17.4391 30.5521 20.8372C30.5521 21.4152 30.0839 21.8838 29.5065 21.8838C28.9291 21.8838 28.461 21.4152 28.461 20.8372C28.461 18.5933 26.6375 16.7679 24.3955 16.7679C22.1536 16.7679 20.3301 18.5933 20.3301 20.8372C20.3301 23.0811 22.1536 24.9068 24.3955 24.9068C24.9729 24.9068 25.4411 25.3754 25.4411 25.9534C25.4411 26.5314 24.9729 27 24.3955 27Z",
    fill: "url(#paint0_linear_12486_30775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3955 27C21.0009 27 18.239 24.2353 18.239 20.8372C18.239 17.4391 21.0009 14.6744 24.3955 14.6744C27.7902 14.6744 30.5521 17.4391 30.5521 20.8372C30.5521 21.4152 30.0839 21.8838 29.5065 21.8838C28.9291 21.8838 28.461 21.4152 28.461 20.8372C28.461 18.5933 26.6375 16.7679 24.3955 16.7679C22.1536 16.7679 20.3301 18.5933 20.3301 20.8372C20.3301 23.0811 22.1536 24.9068 24.3955 24.9068C24.9729 24.9068 25.4411 25.3754 25.4411 25.9534C25.4411 26.5314 24.9729 27 24.3955 27Z",
    fill: "url(#paint1_linear_12486_30775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4565 22.1322H19.2845C18.7071 22.1322 18.239 21.6636 18.239 21.0856C18.239 20.5076 18.7071 20.039 19.2845 20.039H29.4565C30.0339 20.039 30.502 20.5076 30.502 21.0856C30.502 21.6636 30.0339 22.1322 29.4565 22.1322Z",
    fill: "url(#paint2_linear_12486_30775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4565 22.1322H19.2845C18.7071 22.1322 18.239 21.6636 18.239 21.0856C18.239 20.5076 18.7071 20.039 19.2845 20.039H29.4565C30.0339 20.039 30.502 20.5076 30.502 21.0856C30.502 21.6636 30.0339 22.1322 29.4565 22.1322Z",
    fill: "url(#paint3_linear_12486_30775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4565 22.1322H19.2845C18.7071 22.1322 18.239 21.6636 18.239 21.0856C18.239 20.5076 18.7071 20.039 19.2845 20.039H29.4565C30.0339 20.039 30.502 20.5076 30.502 21.0856C30.502 21.6636 30.0339 22.1322 29.4565 22.1322Z",
    fill: "url(#paint4_linear_12486_30775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.50028 24.4262C1.87035 23.7956 1.87035 22.773 2.50028 22.1424C3.13021 21.5119 4.15177 21.5119 4.7817 22.1424C6.85726 24.2201 10.2346 24.2201 12.3102 22.1424C14.3857 20.0647 14.3857 16.6839 12.3102 14.6062C11.6803 13.9757 11.6803 12.9531 12.3102 12.3225C12.9401 11.6919 13.9617 11.6919 14.5916 12.3225C17.9253 15.6595 17.9253 21.0891 14.5916 24.4262C11.2579 27.7632 5.83393 27.7632 2.50028 24.4262Z",
    fill: "url(#paint5_linear_12486_30775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.50028 24.4262C1.87035 23.7956 1.87035 22.773 2.50028 22.1424C3.13021 21.5119 4.15177 21.5119 4.7817 22.1424C6.85726 24.2201 10.2346 24.2201 12.3102 22.1424C14.3857 20.0647 14.3857 16.6839 12.3102 14.6062C11.6803 13.9757 11.6803 12.9531 12.3102 12.3225C12.9401 11.6919 13.9617 11.6919 14.5916 12.3225C17.9253 15.6595 17.9253 21.0891 14.5916 24.4262C11.2579 27.7632 5.83393 27.7632 2.50028 24.4262Z",
    fill: "url(#paint6_linear_12486_30775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.50048 24.4262C-0.833169 21.0891 -0.833169 15.6595 2.50048 12.3225C3.13041 11.6919 4.15198 11.6919 4.78191 12.3225C5.41184 12.9531 5.41184 13.9757 4.78191 14.6062C2.70635 16.6839 2.70635 20.0647 4.78191 22.1424C5.41184 22.773 5.41184 23.7956 4.78191 24.4262C4.15198 25.0568 3.13041 25.0568 2.50048 24.4262Z",
    fill: "url(#paint7_linear_12486_30775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.50048 24.4262C-0.833169 21.0891 -0.833169 15.6595 2.50048 12.3225C3.13041 11.6919 4.15198 11.6919 4.78191 12.3225C5.41184 12.9531 5.41184 13.9757 4.78191 14.6062C2.70635 16.6839 2.70635 20.0647 4.78191 22.1424C5.41184 22.773 5.41184 23.7956 4.78191 24.4262C4.15198 25.0568 3.13041 25.0568 2.50048 24.4262Z",
    fill: "url(#paint8_linear_12486_30775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3103 14.6063C8.97665 11.2692 8.97665 5.83962 12.3103 2.50256C15.644 -0.834511 21.068 -0.834511 24.4016 2.50256C25.0316 3.13313 25.0316 4.15574 24.4016 4.78631C23.7717 5.41689 22.7501 5.41689 22.1202 4.78631C20.0446 2.70863 16.6673 2.70863 14.5917 4.78631C12.5162 6.864 12.5162 10.2448 14.5917 12.3225C15.2217 12.9531 15.2217 13.9757 14.5917 14.6063C13.9618 15.2368 12.9402 15.2368 12.3103 14.6063Z",
    fill: "url(#paint9_linear_12486_30775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3103 14.6063C8.97665 11.2692 8.97665 5.83962 12.3103 2.50256C15.644 -0.834511 21.068 -0.834511 24.4016 2.50256C25.0316 3.13313 25.0316 4.15574 24.4016 4.78631C23.7717 5.41689 22.7501 5.41689 22.1202 4.78631C20.0446 2.70863 16.6673 2.70863 14.5917 4.78631C12.5162 6.864 12.5162 10.2448 14.5917 12.3225C15.2217 12.9531 15.2217 13.9757 14.5917 14.6063C13.9618 15.2368 12.9402 15.2368 12.3103 14.6063Z",
    fill: "url(#paint10_linear_12486_30775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.347 9.24128H24.4942V7.38661C24.4942 7.02457 24.1985 6.72852 23.8368 6.72852C23.4751 6.72852 23.1794 7.02457 23.1794 7.38661V9.24128H21.3266C20.9649 9.24128 20.6692 9.53769 20.6692 9.89938C20.6692 10.2614 20.9649 10.5575 21.3266 10.5575H23.1794V12.4122C23.1794 12.7742 23.4751 13.0702 23.8368 13.0702C24.1985 13.0702 24.4942 12.7742 24.4942 12.4122V10.5575H26.347C26.7087 10.5575 27.0044 10.2611 27.0044 9.89938C27.0044 9.53734 26.7087 9.24128 26.347 9.24128Z",
    fill: "url(#paint11_linear_12486_30775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.347 9.24128H24.4942V7.38661C24.4942 7.02457 24.1985 6.72852 23.8368 6.72852C23.4751 6.72852 23.1794 7.02457 23.1794 7.38661V9.24128H21.3266C20.9649 9.24128 20.6692 9.53769 20.6692 9.89938C20.6692 10.2614 20.9649 10.5575 21.3266 10.5575H23.1794V12.4122C23.1794 12.7742 23.4751 13.0702 23.8368 13.0702C24.1985 13.0702 24.4942 12.7742 24.4942 12.4122V10.5575H26.347C26.7087 10.5575 27.0044 10.2611 27.0044 9.89938C27.0044 9.53734 26.7087 9.24128 26.347 9.24128Z",
    fill: "url(#paint12_linear_12486_30775)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12486_30775",
    x1: 18.239,
    y1: 20.8372,
    x2: 30.5524,
    y2: 20.8372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B2AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64F5D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12486_30775",
    x1: 26.453,
    y1: 16.2319,
    x2: 20.3718,
    y2: 23.2032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73B5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12486_30775",
    x1: 18.2401,
    y1: 21.1763,
    x2: 30.501,
    y2: 20.9953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B5A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64F5D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12486_30775",
    x1: 22.3213,
    y1: 21.8677,
    x2: 22.6247,
    y2: 19.8279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12486_30775",
    x1: 26.4196,
    y1: 20.3035,
    x2: 26.1162,
    y2: 22.3432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73B5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12486_30775",
    x1: 7.31281,
    y1: 24.5187,
    x2: 14.3182,
    y2: 17.5205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64F5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38B2AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12486_30775",
    x1: 7.31313,
    y1: 24.5187,
    x2: 14.3185,
    y2: 17.5205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73B5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0D5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12486_30775",
    x1: 0.0475885,
    y1: 14.7777,
    x2: 7.24135,
    y2: 21.9641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B2AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F5D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12486_30775",
    x1: 0.0476658,
    y1: 21.9714,
    x2: 7.24143,
    y2: 14.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73B5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12486_30775",
    x1: 19.8589,
    y1: 1.90546,
    x2: 12.4181,
    y2: 10.4341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38B2AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12486_30775",
    x1: 19.8592,
    y1: 1.90549,
    x2: 12.4184,
    y2: 10.4341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73B5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12486_30775",
    x1: 20.6692,
    y1: 9.89938,
    x2: 27.0044,
    y2: 9.89938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38B2AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_12486_30775",
    x1: 20.6692,
    y1: 9.89938,
    x2: 27.0044,
    y2: 9.89938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73B5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12486_30775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartnurseIcon);
export default __webpack_public_path__ + "static/media/smartnurse-icon.fee64cc778822493a29b77ae1df65168.svg";
export { ForwardRef as ReactComponent };